import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-b border-carbon-800 bg-carbon-900 py-20 sm:py-24" id="faq" data-id="element-14" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-15" data-mp="1gein8glpax0t">
        <div className="text-center" data-id="element-16" data-mp="2e0zeb43ucee4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-volt" data-id="element-17" data-mp="2dzxw8foeqrmw">
            Preguntas frecuentes
          </p>
          <h2 className="mt-4 text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-18" data-mp="2429yrhzf3611">
            Antes de comprar
          </h2>
        </div>

        <div className="mt-12 divide-y divide-carbon-700 overflow-hidden rounded-xl border border-carbon-700 bg-carbon-850" data-id="element-19" data-mp="1z2njl3013fpl">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-20" data-mp="phy1bk0oa1tw" data-mpi={index}>
                <h3 data-id="element-21" data-mp="pizdjrtfcud7">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-carbon-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-volt" data-id="element-22" data-mp="pih7y4kvh3sm">
                    <span className="text-base font-semibold text-white" data-id="element-23" data-mp="bj82nzy7fu3f">{faq.question}</span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.2
                }} className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded border ${isOpen ? 'border-safety text-safety' : 'border-carbon-600 text-slate-400'}`} data-id="element-24" data-mp="3szpoml3v5xlr">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="1uhw90wyx6knl" />
                    </motion.span>
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-26" data-mp="1pobc7892bwpz">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-27" data-mp="1koynsj2jmhla">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-slate-400" data-id="element-28" data-mp="23jlzo0kz9fkb">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}